import { signal } from '@angular/core';
import { delay } from '@azavista/components/shared';
import { ITokenPayload, IUser } from '@azavista/planner-lib';

export type InitData = 'unauthenticated' | {
    user: IUser;
    token: ITokenPayload;
};

export abstract class CustomerChatbotService {
    currentChatbotUserState: InitData = 'unauthenticated';
    isDisplayed$ = signal(false);
    hideTemporarilyDuration = 15 * 1000; // 15 seconds

    protected abstract initUnAuthenticatedUser(): Promise<void>;
    protected abstract initUserSession(user: IUser, token: ITokenPayload): Promise<void>;
    abstract endUserSession(): Promise<void>;
    protected abstract showChatbot(): Promise<void>;
    protected abstract hideChatbot(): Promise<void>;

    async init(data: InitData) {
        this.currentChatbotUserState = data;
        if (data === 'unauthenticated') {
            await this.initUnAuthenticatedUser();
        } else {
            await this.initUserSession(data.user, data.token);
        }
        this.isDisplayed$.set(true);
    }

    async hideTemporarily() {
        this.hide();
        await delay(this.hideTemporarilyDuration);
        this.show();
    }

    show() {
        this.showChatbot();
        this.isDisplayed$.set(true);
    }

    hide() {
        this.hideChatbot();
        this.isDisplayed$.set(false);
    }
}
